import React from 'react';
import Firebase from 'firebase';
import Row from './row';
import Picker from 'react-month-picker'
import MonthBox from './monthbox'
import Tabla from './tabla'
import Bottom from './bottom'

export default class main extends React.Component {
    constructor() {
        super();
        this.state = {
            days: new Array(),
            num_days: 0,
            auditores: [],
            mvalue: {
                year: new Date().getFullYear(),
                month: (new Date().getMonth() + 1)
            },
            data: []
        }
    }

    componentDidMount() {
        var userRef = Firebase.database().ref("users").orderByChild("client_id").equalTo(localStorage.client_id);
        userRef.once("value").then(resp => {
            var users = new Array();
            resp.forEach(usuario => {
                users.push({
                    value: usuario.val().rut,
                    label: usuario.val().name
                })
            });
            this.setState({ auditores: users })
        });
        var year = new Date().getFullYear();
        var month = (new Date().getMonth() + 1);
        var num_days = new Date(year, month, 0).getDate();
        this.setState({
            year: year,
            month: month,
            num_days: num_days
        })
    }

    renderDays() {
        var days = [];
        for (let index = 1; index <= this.state.num_days; index++) {
            days.push(<th>{index}</th>);
        }
        return days;
    }

    renderRows(auditor) {
        var days = new Array();
        for (let index = 1; index <= this.state.num_days; index++) {
            days.push(<Row user={auditor} day={index} month={this.state.month} year={this.state.year} num_days={this.state.num_days} />);
        }
        return (
            days.map((d, index) => (
                d
            ))
        )
    }

    componentWillUpdate(nextProps, nextState) {
        const contex = this;
        var days = new Array();
        if (nextState.month !== this.state.month) {
            var num_days = new Date(nextState.year, nextState.month, 0).getDate();
            var arr = new Array();
            arr.length = num_days;
            for (let index = 1; index <= num_days; index++) {
                days.push(index);
            }
            this.setState({ num_days: num_days, dias: days, ready: true });
        }
    }


    render() {
        let pickerLang = {
            months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            from: 'From',
            to: 'To'
        }
            , mrange = { from: { year: 2017, month: 1 }, to: { year: 2020, month: 12 } }

        let makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year)
            return '?'
        }
        return (
            <div>
                <div style={{ height: "350px", overflow: "auto" }}>
                    <ul>
                        <li>
                            <label>Seleccione una fecha</label>
                            <div className="edit" onClick={() => { this.setState({ actived: !this.state.actived }) }}>
                                <Picker
                                    show={this.state.actived}
                                    ref="pickAMonth"
                                    years={[2017, 2018, 2019]}
                                    value={this.state.mvalue}
                                    lang={pickerLang.months}
                                    onChange={(año, mes) => {
                                        var mvalue2 = {
                                            year: año,
                                            month: mes
                                        };
                                        this.setState({ mvalue: mvalue2, year: año, month: mes, ready: false, dias: new Array() })
                                    }}
                                >
                                    <MonthBox value={makeText(this.state.mvalue)} />
                                </Picker>
                            </div>
                        </li>
                    </ul>
                    {
                        this.state.ready ?
                            <Tabla style={{ overflow: "auto" }}
                                days={this.renderDays()}
                                auditores={this.state.auditores}
                                dias={this.state.dias}
                                year={this.state.year}
                                month={this.state.month}
                                num_days={this.state.num_days}
                                callBack={(e) => { this.setState({ data: e }) }}
                            />
                            :
                            ""
                    }
                </div>
                <div>
                    <tr>
                        <td style={{ width: "220px" }}>
                            <i className="fa fa-square" style={{ color: "#4dbd74" }}></i> Distancia menor a 200 metros.
                        </td>
                        <td style={{ width: "220px" }}>
                            <i className="fa fa-square" style={{ color: "#eb6651" }}></i> Distancia mayor a 200 metros.
                        </td>
                        <td style={{ width: "110px" }}>
                            <i className="fa fa-sign-in" aria-hidden="true"></i> Hora de inicio.
                        </td>
                        <td style={{ width: "130px" }}>
                            <i className="fa fa-sign-out" aria-hidden="true"></i> Hora de termino.
                        </td>
                        <td style={{ width: "130px" }}>
                            <i className="fa fa-hourglass-end" aria-hidden="true"></i> Tiempo trabajado.
                        </td>
                    </tr>
                </div>
                <div style={{ height: "300px", overflow: "auto", width: "100%" }}>
                    <Bottom datos={this.state.data} />
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/main.js